import Layout from './layout';
import TextAnimation from './TextAnim';
import HeadAnimation from './HeadAnimation';
// import Vue from 'vue';
// import PageForm from "vue/PageForm.vue";
import window from "inputmask/lib/global/window";
import {checkInitGoogleAnalytics, getCookie, mindboxAnonimEdit, mindboxAnonimEditSetEntrancePage} from "~/helperFunctions";
import './speakers'

class App {
    constructor() {
        new TextAnimation();
        new Layout();
        new HeadAnimation();
        this.fixBugSafari(['.info .info__text .stroke-wrapper', '.past .past__text .stroke-wrapper']);
        this.initGTM();
        this.initMobileViewPort();
        this.autoPlayVideo();
    }

    autoPlayVideo() {
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('video[autoplay]').forEach(video => video.play());
        });
    }

    initGTM() {
        document.addEventListener('DOMContentLoaded', () => {
            // <!-- Google Tag Manager -->
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-PBHJ4M');

            checkInitGoogleAnalytics();
            mindboxAnonimEditSetEntrancePage();

            if (getCookie('_delay_mindbox_request') !== undefined) {
                setTimeout(() => {
                    mindboxAnonimEdit();
                }, 500);
            }
        });
    }

    fixBugSafari(arrSelectors) {
        // фикс проблемы с обводкой "Прямой эфир"
        window.onload = () => {
            arrSelectors.forEach(el => {
                const item = document.querySelector(`${el}`);
                if (!item) return;
                item.style.zIndex = "10";
                setTimeout(() => {
                    item.style.zIndex = "10";
                }, 1000);
            });
        };
    }

    initVueForm() {
        if (document.getElementById('vue-page-form')) {
            const vuePageForm = new Vue({
                el: '#vue-page-form',
                render: h => h(PageForm)
            });
        }
    }

    initVideo() {
        const videoItem = document.querySelector('.js-video');
        const videoImg = videoItem.querySelector('img');
        const videoVideo = videoItem.querySelector('iframe');
        videoImg.addEventListener('click', clickPlugVideo);
        function clickPlugVideo() {
            videoImg.remove();
            videoItem.classList.add('video__inner--open');
            videoVideo.style.display = 'block';
            videoVideo.click();
        }
    }

    initMobileViewPort() {
        const mvp = document.querySelector('[name="viewport"]');
        this.setMobileViewPort(mvp);
        window.addEventListener("resize", () => {
            this.setMobileViewPort(mvp);
        });
    }

    setMobileViewPort(mvp) {
        if (screen.width < 365) {
            mvp.setAttribute('content','width=365');
        } else {
            mvp.setAttribute('content','width=device-width, initial-scale=1');
        }
    }
}

new App();